import React from 'react'
import styles from './PrivateKeyStorageModal.module.css';
import useTheme from 'config/useTheme';
const PreExecutionConfirmation = ({ actionName, setConfirmation, handleModal }) => {
    const { dark } = useTheme();
    return (
        <div className={`${dark ? styles.dark : ''} ${styles.confirmation_step}`}>
            <div className={styles.label}>Are you sure you want to {actionName ? actionName : "proceed"}?</div>
            <div className={styles.form_actions}>
                <button onClick={() => setConfirmation(true)}>Yes</button>
                <button onClick={() => handleModal(false)}>No</button>
            </div>
        </div>
    );
}

export default PreExecutionConfirmation;